import React from 'react';
import styles from './BootstrapLoading.module.scss';
import Image from 'next/image';

export interface IBootstrapLoadingProps {
  isLoading?: boolean;
}

export const BootstrapLoading = ({ isLoading }: IBootstrapLoadingProps) =>
  isLoading ? (
    <div className={styles.bootstrap_loading_container}>
      <div className={styles.bootstrap_loading_wrapper}>
        <Image src="/images/main-loading.svg" alt="Winnerz.com" width={160} height={160} priority />
      </div>
    </div>
  ) : null;

export default BootstrapLoading;
